import React from 'react';
import { Route, Routes } from 'react-router-dom';
import HomePage from './Home.js'; // Adjust the import according to your file structure

const App = () => {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} /> {/* Main/home page component */}
            {/* Add other routes as needed */}
        </Routes>
    );
};

export default App;
